import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { fetchSiteDetails } from "TemplatesAction";

class ThemeMenu extends Component {
  componentDidMount() {
    this.props.fetchSiteDetails(this.props.session);
  }

  onMenuClick() {
    var path = _.lowerCase(this.props.item.iconName);
    this.props.history.push(`/dashboard/website/${path}`);
  }

  render() {
    let { siteDetails } = this.props;
    var iconName = _.lowerCase(this.props.item.iconName);

    if (_.endsWith(iconName, "s")) {
      iconName = iconName.substr(0, iconName.length - 1);
    }

    var iconUrl = `../../style/images/websites-icons/${iconName}${
      this.props.selected ? "-Selected" : ""
    }.png`;

    let siteURL = "";
    if (
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].website_subdomain
    ) {
      siteURL =
        "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
    }

    return (
      <li
        className={
          this.props.selected
            ? "list-group-item content-features-li-active"
            : "list-group-item content-features-li"
        }
        style={
          iconName === "wizard" && siteURL === ""
            ? { display: "block" }
            : iconName !== "wizard" && siteURL
            ? { display: "block" }
            : { display: "none" }
        }
        onClick={this.onMenuClick.bind(this)}
      >
        &nbsp;&nbsp;
        <img src={iconUrl} />
        &nbsp;{this.props.item.title}
      </li>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var pathName = _.last(_.split(ownProps.location.pathname, "/"));

  return {
    session: state.session,
    selected: ownProps.item.iconName == pathName,
    siteDetails: state.siteDetails,
  };
}

export default withRouter(
  connect(mapStateToProps, { fetchSiteDetails })(ThemeMenu)
);
